(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lettering-switch"] && !Shopify.designMode) return;
  try {
    class LetteringSwitch extends HTMLElement {
    /** @type {AbortController | undefined} */
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      this.addEventListener('click', this.#onClick, { signal: this.#abort.signal });
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    /** Opens the other color with the same size selected. */
    #onClick = (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[data-switch]') : null;
      if (!(link instanceof HTMLAnchorElement)) return;

      let map = {};
      try {
        map = JSON.parse(link.dataset.variantMap || '{}');
      } catch {
        return;
      }

      const section = this.closest('.shopify-section') ?? document;
      const idInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      const pairVariant = idInput instanceof HTMLInputElement ? map[idInput.value] : undefined;
      if (!pairVariant) return;

      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', String(pairVariant));
      window.location.assign(url.toString());
    };
  }

  if (!customElements.get('lettering-switch')) customElements.define('lettering-switch', LetteringSwitch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["name-switch"] && !Shopify.designMode) return;
  try {
    class NameSwitch extends HTMLElement {
    /** @type {AbortController | undefined} */
    #abort;

    connectedCallback() {
      this.#abort = new AbortController();
      const { signal } = this.#abort;
      this.addEventListener('click', this.#onClick, { signal });
      const section = this.closest('.shopify-section') ?? document;
      section.addEventListener('shopify:product:select', this.#onProductSelect, { signal });
      this.#watchPreviewImage(section, signal);
    }

    /**
     * Printify's Personalize block swaps the main product image for a live
     * preview from personalize.at once a name is saved. That preview is served
     * as application/octet-stream and can be requested before it is rendered,
     * which leaves a broken image on some phones. Retry it a few times, then
     * fall back to the original product image.
     */
    #watchPreviewImage(section, signal) {
      const gallery = section.querySelector('.product-media') ? section : null;
      if (!gallery) return;

      /** @type {WeakSet<HTMLImageElement>} */
      const watched = new WeakSet();
      const handle = (img) => {
        if (!(img instanceof HTMLImageElement) || !img.src.includes('personalize.at')) return;
        if (watched.has(img)) return;
        watched.add(img);
        const tries = new Map();
        img.addEventListener(
          'error',
          () => {
            if (!img.src.includes('personalize.at')) return;
            const url = new URL(img.src);
            url.searchParams.delete('_r');
            const key = url.toString();
            const count = (tries.get(key) ?? 0) + 1;
            tries.set(key, count);
            if (count <= 3) {
              url.searchParams.set('_r', String(Date.now()));
              setTimeout(() => (img.src = url.toString()), 1500 * count);
            } else if (img.dataset.originalSrc) {
              img.src = img.dataset.originalSrc;
            }
          },
          { signal }
        );
      };

      const observer = new MutationObserver((records) => {
        for (const record of records) handle(record.target);
      });
      observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['src'] });
      signal.addEventListener('abort', () => observer.disconnect());
    }

    disconnectedCallback() {
      this.#abort?.abort();
    }

    /** Swaps the "+$" label to match the newly selected size and color. */
    #onProductSelect = async (event) => {
      try {
        const result = await event.promise;
        const id = result?.detail?.resource?.id ?? this.#currentVariantId();
        if (id == null) return;
        const labels = JSON.parse(this.dataset.labelMap || '{}');
        const label = labels[String(id)];
        const target = this.querySelector('[data-named-label]');
        if (label && target) target.textContent = label;
      } catch (error) {
        if (error?.name !== 'AbortError') console.warn('[name-switch] variant label update failed:', error);
      }
    };

    #currentVariantId() {
      const section = this.closest('.shopify-section') ?? document;
      const idInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      return idInput instanceof HTMLInputElement ? idInput.value : null;
    }

    #onClick = (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[data-switch]') : null;
      if (!link) return;

      let map = {};
      try {
        map = JSON.parse(this.dataset.variantMap || '{}');
      } catch {
        return;
      }

      const section = this.closest('.shopify-section') ?? document;
      const idInput = section.querySelector('form[action*="/cart/add"] input[name="id"]');
      const twinVariant = idInput instanceof HTMLInputElement ? map[idInput.value] : undefined;
      if (!twinVariant) return;

      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set('variant', String(twinVariant));
      window.location.assign(url.toString());
    };
  }

  if (!customElements.get('name-switch')) customElements.define('name-switch', NameSwitch);
  } catch(e) { console.error(e); }
})();

})();
